import React from 'react';
import SkillEvaluation from '../components/SkillEvaluationComponent/SkillEvaluation';

const SkillEvaluationPage = () => {
  return (
    <div>
      <SkillEvaluation />
    </div>
  );
};

export default SkillEvaluationPage;
